import { render } from "./CreateDashboard.vue.js?vue&type=template&id=4b4a19bc!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateDashboard.vue?vue&type=template&id=4b4a19bc"
import script from "./CreateDashboard.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateDashboard.vue?vue&type=script&lang=js"
export * from "./CreateDashboard.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/CreateDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b4a19bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b4a19bc', __exports__)) {
    api.reload('4b4a19bc', __exports__)
  }
  
  module.hot.accept("./CreateDashboard.vue.js?vue&type=template&id=4b4a19bc!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreateDashboard.vue?vue&type=template&id=4b4a19bc", () => {
    api.rerender('4b4a19bc', render)
  })

}


export default __exports__